export default __webpack_public_path__ + "static/media/spinner2.c12504a9.gif";